import {
  Award,
  Headphones,
  LayoutTemplate,
  Puzzle,
  Smartphone,
  Sparkles,
} from "lucide-react";
import { motion } from "framer-motion";

const REASONS = [
  {
    n: "01",
    title: "Technologies de pointe",
    description:
      "Des stacks modernes pour des sites rapides, sécurisés et agréables à utiliser au quotidien.",
    icon: Sparkles,
  },
  {
    n: "02",
    title: "Design moderne",
    description:
      "Des interfaces soignées qui reflètent votre marque et donnent envie d’explorer.",
    icon: LayoutTemplate,
  },
  {
    n: "03",
    title: "Design responsive",
    description:
      "Une expérience fluide sur mobile, tablette et desktop — là où vos clients sont.",
    icon: Smartphone,
  },
  {
    n: "04",
    title: "Solutions sur mesure",
    description:
      "Pas de modèle figé : j'adapte chaque projet à vos objectifs et à votre secteur.",
    icon: Puzzle,
  },
  {
    n: "05",
    title: "Accompagnement réactif",
    description:
      "Un accompagnement disponible avant et après la mise en ligne pour faire évoluer votre site.",
    icon: Headphones,
  },
  {
    n: "06",
    title: "Expertise éprouvée",
    description:
      "Des livrables concrets, du vitrine au e-commerce, avec une méthode claire.",
    icon: Award,
  },
];

export default function WhyUsSection() {
  return (
    <section
      id="why-us"
      className="relative w-full overflow-hidden bg-surface-raised py-24 md:py-32"
      aria-label="Pourquoi me choisir"
    >
      <div
        className="pointer-events-none absolute inset-0 bg-grid-fine bg-grid opacity-30"
        aria-hidden
      />
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Valeurs</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-5xl">
            Pourquoi moi
          </h2>
          <p className="mt-4 text-balance text-lg text-zinc-500">
            Ce qui me distingue quand il s’agit de bâtir une présence digitale durable.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {REASONS.map((item, i) => (
            <motion.article
              key={item.n}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="rounded-2xl border border-white/[0.06] bg-surface-card p-7 transition hover:border-brand/20"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="font-mono text-sm text-zinc-600">{item.n}</span>
                <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/[0.04] text-brand">
                  <item.icon className="h-5 w-5" strokeWidth={1.75} />
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold text-white">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-500">{item.description}</p>
            </motion.article>
          ))}
        </div>

        <div className="mx-auto mt-14 text-center">
          <a
            href="#contact"
            className="inline-flex items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] px-8 py-3.5 text-sm font-semibold text-white transition hover:border-brand/35 hover:bg-white/[0.07]"
          >
            Démarrer un projet
          </a>
        </div>
      </div>
    </section>
  );
}
